// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class BasicEnrollmentDeactivateRequest {
    static getAttributeTypeMap() {
        return BasicEnrollmentDeactivateRequest.attributeTypeMap;
    }
}
BasicEnrollmentDeactivateRequest.discriminator = undefined;
BasicEnrollmentDeactivateRequest.additionalProperties = false;
BasicEnrollmentDeactivateRequest.attributeTypeMap = [
    {
        "name": "enrollmentId",
        "baseName": "enrollmentId",
        "type": "number"
    },
    {
        "name": "effectiveDate",
        "baseName": "effectiveDate",
        "type": "Date"
    },
];
//# sourceMappingURL=basicEnrollmentDeactivateRequest.js.map